import axios from './axios-login';

const logar = loginData => axios.post('/auth/login', loginData);
const solicitarSenha = data => axios.post('/open/users/reset-password', data);
const redefinirSenha = (chave, data) => axios.post(`/open/users/reset-password/${chave}`, data);
const validarChave = chave => axios.get(`/open/users/reset-password/${chave}`);

export default {
  logar,
  validarChave,
  solicitarSenha,
  redefinirSenha,
};
